<template>
  <ul class="order-list">
    <li
      class="order-item"
      v-for="(order, index) in orders"
      :key="index"
      @click="$emit('card-click', order.id)"
    >
      <div class="order-card">
        <!-- Заголовок -->
        <div class="card-header">
          <div class="card-title-section">
            <h3 class="order-title">
              <span class="title-text">
                Заказ #{{ order.number }}:
              </span>
              <span v-if="order.cargo_name">
                {{ order.cargo_name }}
              </span>
            </h3>
            <div class="header-badges">
              <div class="badge-group">
                <span class="badge-label">Статус заказа</span>
                <span
                  class="status-badge"
                  :style="{
                    'background-color': orderStore.orderStatusColor(
                      order.status
                    ),
                  }"
                >
                  {{ orderStore.formatOrderStatus(order.status) }}
                </span>
              </div>
              <div class="badge-group" v-if="order.payment_status">
                <span class="badge-label">Статус оплаты</span>
                <span
                  class="status-badge"
                  :style="{
                    'background-color': orderStore.paymentStatusColor(
                      order.payment_status
                    ),
                  }"
                >
                  {{
                    orderStore.formatPaymentStatus(
                      order.payment_status
                    )
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Основной контент -->
        <div class="card-content">
          <!-- Блок: Основное -->
          <div class="info-card main-info-card">
            <div class="card-section-header">
              <div class="section-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4"
                    stroke="#000"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h4 class="section-title">Основное</h4>
            </div>
            <div class="card-section-content">
              <div class="detail-item" v-if="order.route_cities">
                <span class="detail-label">Маршрут:</span>
                <span class="detail-value">
                  {{ order.route_cities }}
                </span>
              </div>
              <div class="detail-item" v-if="order.price">
                <span class="detail-label">Цена:</span>
                <span class="detail-value price-value">
                  {{ formatBigNumber(order.price, true) }} ₽
                </span>
              </div>
              <div
                class="detail-item"
                v-if="
                  order.status != 'completed' &&
                  order.status != 'cancelled' &&
                  order.planned_pickup_at
                "
              >
                <span class="detail-label">Погрузка (план):</span>
                <span class="detail-value">
                  {{ formatDateAndTime(order.planned_pickup_at) }}
                </span>
              </div>
              <div
                class="detail-item"
                v-if="
                  order.status != 'completed' &&
                  order.status != 'cancelled' &&
                  order.planned_delivery_at
                "
              >
                <span class="detail-label">Доставка (план):</span>
                <span class="detail-value">
                  {{ formatDateAndTime(order.planned_delivery_at) }}
                </span>
              </div>
              <div
                class="detail-item"
                v-if="
                  (order.status == 'completed' ||
                    order.status == 'cancelled') &&
                  order.actual_pickup_at
                "
              >
                <span class="detail-label">Погрузка (факт):</span>
                <span class="detail-value">
                  {{ formatDateAndTime(order.actual_pickup_at) }}
                </span>
              </div>
              <div
                class="detail-item"
                v-if="
                  (order.status == 'completed' ||
                    order.status == 'cancelled') &&
                  order.actual_delivery_at
                "
              >
                <span class="detail-label">Доставка (факт):</span>
                <span class="detail-value">
                  {{ formatDateAndTime(order.actual_delivery_at) }}
                </span>
              </div>
              <div
                class="detail-item"
                v-if="
                  order.status === 'completed' &&
                  order.actual_delivery_at
                "
              >
                <span class="detail-label">Заказ завершён:</span>
                <span class="detail-value completed-date">
                  {{ formatDateAndTime(order.actual_delivery_at) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Правая сетка -->
          <div class="secondary-grid">
            <!-- Контрагенты -->
            <div
              class="info-card"
              v-if="
                order.carrier_id ||
                order.customer_id ||
                order.shipper_id ||
                order.consignee_id ||
                order.forwarder_id
              "
            >
              <div class="card-section-header">
                <div class="section-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                      stroke="#000"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <circle
                      cx="9"
                      cy="7"
                      r="4"
                      stroke="#000"
                      stroke-width="2"
                    />
                    <path
                      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                      stroke="#000"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88"
                      stroke="#000"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <h4 class="section-title">Контрагенты</h4>
              </div>
              <div class="card-section-content">
                <div class="entity-card" v-if="order.customer_id">
                  <div class="entity-role">Заказчик</div>
                  <div class="entity-name">
                    {{ order.customer_name }}
                  </div>
                </div>
                <div class="entity-card" v-if="order.shipper_id">
                  <div class="entity-role">Грузоотправитель</div>
                  <div class="entity-name">
                    {{ order.shipper_name }}
                  </div>
                </div>
                <div class="entity-card" v-if="order.consignee_id">
                  <div class="entity-role">Грузополучатель</div>
                  <div class="entity-name">
                    {{ order.consignee_name }}
                  </div>
                </div>
                <div class="entity-card" v-if="order.carrier_id">
                  <div class="entity-role">Перевозчик</div>
                  <div class="entity-name">
                    {{ order.carrier_name }}
                  </div>
                </div>
                <div class="entity-card" v-if="order.forwarder_id">
                  <div class="entity-role">Экспедитор</div>
                  <div class="entity-name">
                    {{ order.forwarder_name }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Транспорт -->
            <div
              class="info-card"
              v-if="order.vehicles && order.vehicles.length > 0"
            >
              <div class="card-section-header">
                <div class="section-icon">
                  <svg
                    fill="#000000"
                    height="22px"
                    width="22px"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    transform="matrix(-1, 0, 0, 1, 0, 0)"
                  >
                    <path
                      d="m480.6,53h-253.2c-11.3,0-20.4,9.1-20.4,20.4v85.7h-73.6c-5.8,0-11.4,2.5-15.3,6.9l-102,115c-3.3,3.7-5.1,8.5-5.1,13.5v96.5c0,11.3 9.1,20.4 20.4,20.4h31.2c9.9,27.8 36.4,47.7 67.6,47.7 31.2,0 57.7-19.9 67.6-47.7h29.5 93.5c9.9,27.8 36.4,47.7 67.6,47.7s57.7-19.9 67.6-47.7h24.6c11.3,0 20.4-9.1 20.4-20.4v-317.6c0-11.3-9.1-20.4-20.4-20.4zm-350.3,365.2c-17,0-30.9-13.8-30.9-30.8 0-17 13.9-30.8 30.9-30.8 17,0 30.9,13.8 30.9,30.8-0.1,17-13.9,30.8-30.9,30.8zm0-102.4c-33.7,0-62.1,23.4-69.7,54.7h-8.7v-68.4l90.7-102.3h64.4v170.7h-7c-7.7-31.3-36-54.7-69.7-54.7zm258.1,102.4c-17,0-30.9-13.8-30.9-30.8 0-17 13.9-30.8 30.9-30.8 17,0 30.9,13.8 30.9,30.8 5.68434e-14,17-13.9,30.8-30.9,30.8zm71.8-47.7h-2.1c-7.6-31.4-36-54.7-69.7-54.7s-62.1,23.4-69.7,54.7h-71v-191-85.7h212.4v276.7z"
                    />
                  </svg>
                </div>
                <h4 class="section-title">Транспорт</h4>
                <span class="section-count">
                  {{ order.vehicles.length }}
                </span>
              </div>
              <div class="card-section-content">
                <div
                  class="entity-card"
                  v-for="(vehicle, vIndex) in order.vehicles"
                  :key="vIndex"
                >
                  <VehicleEntityLink
                    v-if="vehicleIsObject(vehicle)"
                    :vehicle="vehicle"
                  />
                  <div v-else class="entity-name">{{ vehicle }}</div>
                </div>
              </div>
            </div>

            <!-- Контакты -->
            <div
              class="info-card"
              v-if="order.sender || order.receiver"
            >
              <div class="card-section-header">
                <div class="section-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                      stroke="#000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="7"
                      r="4"
                      stroke="#000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <h4 class="section-title">Контакты</h4>
              </div>
              <div class="card-section-content">
                <div class="detail-item" v-if="order.sender">
                  <span class="detail-label">Отправитель:</span>
                  <span class="detail-value">{{ order.sender }}</span>
                </div>
                <div class="detail-item" v-if="order.receiver">
                  <span class="detail-label">Получатель:</span>
                  <span class="detail-value">
                    {{ order.receiver }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Футер -->
        <div
          class="card-footer"
          v-if="order.created_at || order.updated_at"
        >
          <MetaTime
            :created-at="order.created_at"
            :updated-at="order.updated_at"
          />
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import MetaTime from "@/components/Meta/MetaTime.vue";
import VehicleEntityLink from "@/components/Vehicle/VehicleEntityLink.vue";

import { useOrderStore } from "@/stores/orderStore";

import { formatDateAndTime } from "@/utils/dateUtils";
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderCardList",
  components: {
    MetaTime,
    VehicleEntityLink,
  },
  props: {
    orders: {
      type: Array,
      required: true,
    },
  },
  emits: ["card-click"],
  computed: {
    orderStore() {
      return useOrderStore();
    },
  },
  methods: {
    formatDateAndTime,
    formatBigNumber,
    vehicleIsObject(vehicle) {
      return vehicle && typeof vehicle === "object";
    },
  },
};
</script>

<style scoped>
.order-list {
  display: flex;
  flex-direction: column;
  gap: var(--base-out-indent);
}

.order-item {
  cursor: pointer;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.order-item:hover .order-card {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.card-header {
  padding: var(--base-in-indent);
}

.card-title-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
}

.order-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--color-dark);
  flex: 1;
}

.title-text {
  color: #666;
  font-weight: 500;
}

.header-badges {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}

.badge-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.badge-label {
  font-size: 11px;
  color: #999;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}

.card-content {
  padding: 0 var(--base-in-indent) var(--base-in-indent);
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.info-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: var(--base-in-indent);
}

.card-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-dark);
}

.section-count {
  background: #667eea;
  color: #fff;
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 14px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}

.card-section-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.detail-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
}

.detail-value {
  font-size: 14px;
  color: var(--color-dark);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.price-value {
  color: var(--color-green);
  font-weight: 700;
}

.completed-date {
  color: var(--color-green);
  font-weight: 700;
}

.entity-card {
  background: rgb(240, 240, 240);
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 12px;
}

.entity-role {
  font-size: 12px;
  color: #666;
  font-weight: 600;
  margin-bottom: 4px;
}

.entity-name {
  font-size: 14px;
  color: var(--color-dark);
  font-weight: 500;
}

.secondary-grid {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.card-footer {
  padding: var(--base-in-indent);
  border-top: 1px solid #f0f0f0;
}

@media (min-width: 1024px) {
  .card-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: var(--base-in-indent);
  }

  .secondary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 767px) {
  .card-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--base-in-indent);
  }

  .order-title {
    font-size: 16px;
    width: 100%;
  }

  .header-badges {
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: var(--base-in-indent);
  }

  .badge-group {
    align-items: flex-start;
  }

  .status-badge {
    width: 100%;
    padding: 6px 12px;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .detail-value {
    text-align: left;
  }
}
</style>
